import { performanceAssessmentKeys } from '@/composables/performanceAssessment.keys';
import { invalidatePerformanceAssessmentEntryQueries } from '@/composables/performanceAssessmentEntry/performanceAssessmentEntryQueryInvalidation';
import { schoolSubjectKeys } from '@/composables/schoolSubject/schoolSubject.keys';
import type { QueryClient } from '@tanstack/vue-query';

export const invalidateSubjectSpecificPerformanceAssessmentQueries = async (
  queryClient: QueryClient,
  schoolClassId?: number | null,
): Promise<void> => {
  const invalidations: Promise<unknown>[] = [
    queryClient.invalidateQueries({ queryKey: schoolSubjectKeys.lists() }),
    queryClient.invalidateQueries({ queryKey: schoolSubjectKeys.details() }),
    queryClient.invalidateQueries({ queryKey: performanceAssessmentKeys.lists() }),
  ];

  if (schoolClassId != null) {
    invalidations.push(invalidatePerformanceAssessmentEntryQueries(queryClient, schoolClassId));
  }

  await Promise.all(invalidations);
};
